module.exports = __webpack_public_path__ + "assets/img/ef8fdb02fc6b826b7219d9b97296d50f.png";